export var ACTION;
(function (ACTION) {
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["NAVIGATION"] = "NAVIGATION";
    ACTION["EMAIL"] = "EMAIL";
    ACTION["ENHANCE_LIMIT"] = "ENHANCE_LIMIT";
    ACTION["MARGIN_CALL"] = "MARGIN_CALL";
    ACTION["GET_COLLATERAL"] = "GET_COLLATERAL";
    ACTION["MENU"] = "MENU";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["INPROGRESS_PROCESS_NAVIGATE"] = "INPROGRESS_PROCESS_NAVIGATE";
    ACTION["GOT_IT_HANDLE"] = "GOT_IT_HANDLE";
})(ACTION || (ACTION = {}));
